import checkServerVersion from '../utils/checkServerVersion';
import Service from './Service';
import UserAccount from './UserAccount';
import io from 'socket.io-client';
import Constants from '../submodules/logictry_config/constants';

const socket = io(Constants.logictryOrigin.replace('https:', 'wss:'), { path: '/socket.io' });

const joinRoom = () => {
  if (UserAccount.isLoggedIn) socket.emit('client-join-room', UserAccount.account._id);
}

class Websockets extends Service {
  setConnectionCount(count) {
    this.connectionCount = count;
    this.emitStateUpdate();
  }
}

const singleton = new Websockets();
UserAccount.onStateUpdate(joinRoom);

socket.on('server-version', (msg) => {
  checkServerVersion(msg);
});
socket.on('server-total-connections', (msg) => {
  if (UserAccount.isDevAccount) singleton.setConnectionCount(msg);
});
// socket.on('server-join-room', (msg) => {
//   if (UserAccount.isDevAccount) console.log('Room count', msg)
// });
// socket.on('server-user-account-update', (msg) => {
//   if (UserAccount.isLoggedIn && msg === 'logout') window.location.reload();
//   if (!UserAccount.isLoggedIn && msg === 'login') window.location.reload();
// });
socket.on('reconnect', joinRoom);

export default singleton;
